<template>
  <div v-if="activePage !== ''" class="patient-menu">
    <div class="patient-btn-area clearfix">
      <div :class="[activePage === 'graph' ? 'btn-patient-active' : 'btn-patient']" @click="setActivePage('graph')">
        <a href="javascript:;">
          <p>
            <span :class="[ activePage === 'graph' ? 'icon-graph-active' : 'icon-graph']">{{ $t('seizure_status_graph_by_seizure_type') }}</span>
          </p>
        </a>
      </div>
      <div :class="[activePage === 'sleep-management' ? 'btn-patient-active' : 'btn-patient']" @click="setActivePage('sleep-management')">
        <a href="javascript:;">
          <p>
            <span :class="[ activePage === 'sleep-management' ? 'icon-24h-management-active' : 'icon-24h-management']">24H発作表</span>
          </p>
        </a>
      </div>
      <div v-if="$store.state.auth.typeOfUser !== 'pharmacy' " :class="[activePage === 'video' ? 'btn-patient-active' : 'btn-patient']" @click="setActivePage('video')">
        <a href="javascript:;">
          <p>
            <span :class="[ activePage === 'video' ? 'icon-movie-active' : 'icon-movie']">{{ $t('video') }}</span>
          </p>
        </a>
      </div>
      <div v-if="$store.state.auth.typeOfUser !== 'pharmacy' && $store.state.auth.doctorInfo.seizure_change_rate_flg" :class="[activePage === 'graph-seizure-change-rate' ? 'btn-patient-active' : 'btn-patient']" @click="setActivePage('graph-seizure-change-rate')">
        <a href="javascript:;">
          <p>
            <span :class="[ activePage === 'graph-seizure-change-rate' ? 'icon-change-active' : 'icon-change']">{{ $t('seizure_change_rate_graph') }}</span>
          </p>
        </a>
      </div>
      <div :class="[activePage === 'basic-information' ? 'btn-patient-active' : 'btn-patient']" @click="setActivePage('basic-information')">
        <a href="javascript:;">
          <p>
            <span :class="[ activePage === 'basic-information' ? 'icon-basic-information-active' : 'icon-basic-information']">{{ $t('basic_information') }}</span>
          </p>
        </a>
      </div>
      <div :class="[activePage === 'medication-status' ? 'btn-patient-active' : 'btn-patient']" @click="setActivePage('medication-status')">
        <a href="javascript:;">
          <p>
            <span :class="[ activePage === 'medication-status' ? 'icon-medication-status-active' : 'icon-medication-status']">{{ $t('medication_status') }}</span>
          </p>
        </a>
      </div>
      <div :class="[activePage === 'vaccination' ? 'btn-patient-active' : 'btn-patient']" @click="setActivePage('vaccination')">
        <a href="javascript:;">
          <p>
            <span :class="[ activePage === 'vaccination' ? 'icon-vaccination-active' : 'icon-vaccination']">{{ $t('vaccination') }}</span>
          </p>
        </a>
      </div>
      <div 
        v-if="isShowHomeCare" 
        :class="[activePage === 'home-care-note-book' ? 'btn-patient-active' : 'btn-patient']" 
        @click="setActivePage('home-care-note-book')">
        <a href="javascript:;">
          <p>
            <span :class="[ activePage === 'home-care-note-book' ? 'icon-home-care-note-book-active' : 'icon-home-care-note-book']">{{ $t('home_care_notebook') }}</span>
          </p>
        </a>
      </div>
    </div>
    <div v-if="activePage === 'basic-information' || (activePage === 'home-care-note-book' && listTabHomeCareHaveData.length > 0)" class="sub-menu-area">
      <div class="sub-menu-scrollable">
        <div v-if="activePage === 'basic-information'" class="sub-menu sub-menu-basic-info">
          <div 
              v-for="(tab, index) in listTabBasic"
              @click="activeSubMenuItem(tab)"
              :class="activeBasicTab === tab ? 'sub-menu-item-active' : 'sub-menu-item'"
              :key="tab"
          >
            {{listTabBasicTitle[index]}}
          </div>
        </div>
        <template v-else-if="activePage === 'home-care-note-book' && listTabHomeCareHaveData.length > 0" >
          <div class="sub-menu sub-menu-home-care">
            <template v-for="(tab, index) in listTabHomeCare">
              <div
                v-if="listTabHomeCareHaveData.includes(tab)"
                @click="activeSubMenuItem(tab)"
                :class="activeHomeCareTab === tab ? 'sub-menu-item-active' : 'sub-menu-item'"
                :key="tab"
              >
                {{listTabHomeCareTitle[index]}}
              </div>
            </template>
          </div>
          <div class="export-homecare-btn-area">
            <div class="export-homecare-btn" @click="onClickExportHomecarePDF">
              {{ $t('pdf_export') }}
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>

import { getOffset, scrollToElement, HEADER_ELEMENT_HEIGHT } from '@/js/commons/commons'

export default {
  props: {
    activePage: {
      type: String,
      required: true
    },
    activeBasicTab: {
      type: String,
      required: true
    },
    listTabBasic: {
      type: Array,
      required: true
    },
    activeHomeCareTab: {
      type: String,
      required: true
    },
    listTabHomeCare: {
      type: Array,
      required: true
    },
    listTabHomeCareHaveData: {
      type: Array,
      required: true
    }
  },
  data() {
      return {
        listTabBasicTitle: [this.$t('basic_information_seizure_information'), this.$t('allergy'), this.$t('medical_history'), this.$t('hospital_visiting_history')],
        listTabHomeCareTitle: ['経管栄養', '吸引・気管切開', '酸素', '中心静脈栄養', '導尿', '腹膜透析', '人工呼吸器', 'インスリン'],
        hostpitalNameNeedToCheck: '大阪母子医療センター'
      }
    },
  computed: {
    isShowHomeCare() {
      return (
        this.$store.state.auth.typeOfUser !== 'pharmacy'
        && this.$store.state.auth.doctorInfo.home_care_flag === 1
        && this.$store.state.patient.info.visited_hospital
      )
    }
  },
  methods: {
    onClickExportHomecarePDF() {
      this.$bvModal.show('modal-pdf')
    },
    setActivePage(val) {
      if (window.screen.width <= 1280 && window.screen.height >= 768) {
        var styleInput = document.querySelectorAll('.style-input')
        var patientDetailArea = document.getElementById('patient-detail-area')
        var patientPic = document.getElementsByClassName('patient-pic')[0]
        var fontWeightBold = document.getElementsByClassName('font-weight-bold')[0]
        var patientBtn = document.getElementsByClassName('patient-btn-area')[0]
        var patientBtnChild = document.getElementsByClassName('patient-btn-area')[0].children
        patientPic.style.width = '60px !important'
        fontWeightBold.style.fontSize = '1.2rem'
        patientDetailArea.style.fontSize = '0.8rem'
        patientBtn.style.padding = '0 20px 0 20px'
        styleInput.forEach(element => {
          element.style.lineHeight = '24px'
          element.style.width = '100px'
          element.style.height = '30px !important'
        })
        for (let i = 0; i < patientBtnChild.length; i++) {
          if(patientBtnChild[i]) {
            patientBtnChild[i].style.marginRight = '10px';
            patientBtnChild[i].style.padding = '0 10px';
            patientBtnChild[i].style.marginBottom = '5px';
            patientBtnChild[i].style.fontSize = '0.7rem';
            patientBtnChild[i].children[0].style.padding = '5px 0';
            patientBtnChild[i].children[0].children[0].children[0].style.backgroundSize = '15px 15px';
            patientBtnChild[i].children[0].children[0].children[0].style.padding = '2px 0 5px 20px';
          }
        }
      }
      let event = null
      switch (val) {
        case 'sleep-management':
          event = { event: '24時間発作表', event_category: this.$t('patient_information'), event_label: '24時間発作表' }
          break
        case 'graph-seizure-change-rate':
          event = { event: this.$t('seizure_change_rate_graph'), event_category: this.$t('patient_information'), event_label: this.$t('seizure_change_rate_graph') }
          break
        case 'basic-information':
          event = { event: this.$t('basic_information'), event_category: this.$t('patient_information'), event_label: this.$t('basic_information') }
          break
        case 'medication-status':
          event = { event: this.$t('medication_status'), event_category: this.$t('patient_information'), event_label: this.$t('medication_status') }
          break
        case 'vaccination':
          event = { event: this.$t('vaccination'), event_category: this.$t('patient_information'), event_label: this.$t('vaccination') }
          break
        case 'graph':
          event = { event: this.$t('Seizure_graph_with_seizure_type'), event_category: this.$t('patient_information'), event_label: this.$t('Seizure_graph_with_seizure_type') }
          break
        case 'video':
          event = { event: this.$t('video'), event_category: this.$t('patient_information'), event_label: this.$t('video') }
          break
        default:
          break
      }
      if (event) {
        this.eventTracking(event)
      }
      this.changeLayout(val)
      this.$emit('setActivePage', val)
    },
    async activeSubMenuItem(activeTab) {
      let heightOfMenuPatientElement = Math.floor(document.getElementsByClassName('patient-menu')[0].offsetHeight)
      let targetPosition = Math.floor(getOffset(document.getElementById(activeTab)).top - (heightOfMenuPatientElement + HEADER_ELEMENT_HEIGHT))
      this.activePage === 'home-care-note-book' ? this.$emit('setActiveHomeCareTab', activeTab) : this.$emit('setActiveBasicTab', activeTab)
      // set target scroll position if current scroll position != with the  target position and we still can scroll down
      if (
        this.targetScrollPosition != Math.floor(window.scrollY)
        && Math.floor(document.documentElement.offsetHeight + document.documentElement.scrollTop) <= Math.floor(document.documentElement.scrollHeight)
      ) {
        this.$emit('setTargetScrollPosition', targetPosition)
        scrollToElement(activeTab, -(heightOfMenuPatientElement + HEADER_ELEMENT_HEIGHT))
      }
    },
    changeLayout(val) {
      var mainContent = document.getElementById('main-contents')
      var space = document.getElementsByClassName('space')[0]
      if (val === 'sleep-management') {
        if (window.screen.width <= 1280 && window.screen.height >= 768) {
          document.getElementsByClassName('search-24-icon-area')[0].style.paddingBottom = '10px'
          space.style.height = '10px'
          space.style.top = '109px'
          document.getElementsByClassName('search-24-check-area')[0].children[1].style.marginBottom = '10px'
        }
        mainContent.style.lineHeight = "unset"
      } else {
        mainContent.style.lineHeight = "1.4rem"
      }
    }
  },
  mounted() {
    if (window.screen.width <= 1280 && window.screen.height >= 768) {
      document.getElementsByClassName('font-weight-bold')[0].style.fontSize = '1.2rem'
      document.getElementById('patient-detail-area').style.fontSize = '0.8rem'
    }
  }
}
</script>
<style scoped>
  .export-homecare-btn-area {
    width: 130px;
    height: 31px;
    margin: 20px 0 0 5px;
  }
  .export-homecare-btn {
    padding: 0 20px;
    background-color: #FF8EA1;
    color: white;
    font-size: 12px;
    width: 130px;
    line-height: 30px;
    border-radius: 15px;
    text-align: center;
  }
  .export-homecare-btn:hover {
    cursor: pointer;
  }
</style>
